module.exports = __webpack_public_path__ + "img/Jerk Sandwich-Pork_.ad799571.jpg";